export default __webpack_public_path__ + "static/media/bookmarks.1fe44afb.svg";